<template>
<v-avatar :size="size" color="grey">
  <img class="pa-1" :class="classLogo" :style="styleLogo" src="@/assets/logo.svg" />
</v-avatar>
</template>

<script>
export default {
  name: 'RotatingLogo',
  props: {
    size: {
      type: [Number, String],
      default: 48,
    },
    speed: {
      type: Number,
      default: 2
    },
    direction: {
      type: Number,
      default: 1
    }
  },
  computed: {
    styleLogo() {
      return {
        'animation-duration': `${this.speed}s`
      };
    },
    classLogo() {
      return {
        'rotating_forward': !!this.direction,
        'rotating_backward': !this.direction
      };
    }
  }
}
</script>

<style scoped>
@keyframes rotating_forward {
  from {
    transform: rotate(0deg);
    -o-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
    -o-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes rotating_forward {
  from {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@keyframes rotating_backward {
  to {
    transform: rotate(0deg);
    -o-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  from {
    transform: rotate(360deg);
    -o-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes rotating_backward {
  to {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  from {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

.rotating_forward {
  -webkit-animation: rotating_forward 1s linear infinite;
  -moz-animation: rotating_forward 1s linear infinite;
  -ms-animation: rotating_forward 1s linear infinite;
  -o-animation: rotating_forward 1s linear infinite;
  animation: rotating_forward 1s linear infinite;
}

.rotating_backward {
  -webkit-animation: rotating_backward 1s linear infinite;
  -moz-animation: rotating_backward 1s linear infinite;
  -ms-animation: rotating_backward 1s linear infinite;
  -o-animation: rotating_backward 1s linear infinite;
  animation: rotating_backward 1s linear infinite;
}
</style>
